import styled from "@emotion/styled";
import { toast as sonnerToast } from "sonner";

import Button, { CombinedButtonProps } from "../button/Button";

/**
 * If you use ToastButton instead of the object approach, you need to manage closing the toast yourself
 *
 * Therefore, I recommend only using this for links that provides a UX benefit currently and our lack of an
 * SPA meaning it will close when the page changes
 */
export const ToastButton = styled(Button)({
  marginLeft: "var(--toast-button-margin-start)",
  marginRight: "var(--toast-button-margin-end)",
  height: "28px",
}) as unknown as CombinedButtonProps; // styled looses the anchor version so need to cast it back to the original type

export default sonnerToast;
